import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LotusIcon from "@/components/icons/LotusIcon";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col" data-testid="not-found-page">
      <Header />
      
      <main className="flex-grow flex items-center justify-center bg-gradient-to-b from-background to-sage-dark pt-20">
        <div className="container text-center py-20">
          <LotusIcon size={80} className="mx-auto mb-8 text-accent animate-float" />
          
          <h1 className="font-serif text-6xl md:text-8xl font-bold text-primary mb-4">
            404
          </h1>
          
          <h2 className="font-serif text-2xl md:text-3xl text-muted-foreground mb-6">
            This path leads elsewhere...
          </h2>
          
          <p className="text-muted-foreground max-w-md mx-auto mb-8">
            The page you're looking for seems to have wandered into the cosmos. 
            Let us guide you back to your journey of transformation.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/" 
              className="btn-lime"
            >
              Return Home
            </Link>
            <Link 
              to="/discovery/relationship-quiz" 
              className="btn-lime-outline"
            >
              Take a Quiz
            </Link>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
